import Rails from './rails/rails-ujs'
import "@hotwired/turbo-rails"
import "./lib/gimmo_confirm"
import "./controllers/gimmo"
import Forms from './elements/forms'
import ImageLazyLoading from './lib/image_lazy_loading'

Rails.start()
Forms.start()
ImageLazyLoading.start()
